(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["erp-summer-break-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSummerBreakBanner() {
      var banner = document.querySelector('[data-erp-summer-break-banner]');
      if (!banner) return;

      var expiresAt = banner.getAttribute('data-expires-at');
      if (expiresAt) {
        var expiryDate = new Date(expiresAt);
        if (!Number.isNaN(expiryDate.getTime()) && new Date() >= expiryDate) {
          banner.hidden = true;
          return;
        }
      }

      var storageKey = banner.getAttribute('data-storage-key') || 'erp-summer-break-banner-dismissed';
      try {
        if (window.localStorage.getItem(storageKey) === '1') {
          banner.hidden = true;
          return;
        }
      } catch (error) {
      }

      banner.hidden = false;

      var closeButton = banner.querySelector('[data-erp-summer-break-banner-close]');
      if (!closeButton) return;

      closeButton.addEventListener('click', function () {
        try {
          window.localStorage.setItem(storageKey, '1');
        } catch (error) {
        }
        banner.hidden = true;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSummerBreakBanner, { once: true });
    } else {
      initSummerBreakBanner();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
